let isHttps = false;
if (window.location.protocol == "https:") {
  isHttps = true;
}
global.routeSecure = isHttps


//////////////////
// WEBPACK FOOTER
// ./static/js/globalParams.js
// module id = xSEe
// module chunks = 2